import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/components/vant";
import App from "./App";
import store from "./store";
import router from "./router";
import "@/config/permission";
import Vab from "@/utils/vab";
import VueAMap from "vue-amap";

Vue.use(ElementUI);
Vue.use(Vab);
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  key: "8d7f6c7e282bb93e949c2018ca77bbde",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.TruckDriving",
    "AMap.Geocoder",
  ],
  v: "1.4.4",
});

window._AMapSecurityConfig = {
  securityJsCode: "39a1139dc1fdb5df106ef15b8af3a1ca",
};

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
